<div class="td-wb-skip"
     role="navigation"
     aria-labelledby="td-wb-menu__skip-to-content-link">
  <a href=""
     id="td-wb-menu__skip-to-content-link"
     (click)="skipToContent()"
     translate="tdWb.menu.SKIP_TO_CONTENT">
  </a>
</div>
@if (!isHidden) {
  <div class="td-wb-menu-container"
       tdWbStickyMenuContainer>
    <!-- Menu bars / side menu-->
    <div class="td-wb-header"
         tdWbStickyMenu>
      <div class="td-wb-nav">
        <div class="td-wb-nav__container">
          <div class="td-wb-content"
               #content>
            <div class="td-wb-menu-top-container">
              <td-wb-menu-global-navigation [@navigationAnimation]
                class="td-wb-angular-animate"
                [navigationMenu]="menu.globalNavigation"
                flyoutType="primary"
                (selected)="onGlobalNavigationSelected()" />
              <td-wb-menu-top-navigation [@navigationAnimation]
                class="td-wb-angular-animate"
                [clientName]="clientName"
                [logoutItem]="logoutItem"
                [navigationMenu]="menu"
                [isTopMenuEnabled]="isLocalMenuEnabled"
                flyoutType="primary"
                (selected)="onTopNavigationSelected()" />
            </div>
            @if (isLocalMenuEnabled) {
              <td-wb-menu-local-navigation [@navigationAnimation]
                class="td-wb-angular-animate"
                [navigationMenu]="menu"
                [activeItemId]="getActiveItemId()"
                flyoutType="secondary"
                (selected)="onLocalNavigationSelected()" />
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
